import React from "react";
import Container from "../../../atoms/page/Page";
import SimpleModal from "../../../organisms/standard-modal/SimpleModal";
import useDimensions from "../../../../hooks/useDimensions";
import { RENDERED_DIMENSIONS } from "./ReportingPagePreviewTile";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  headingHeight?: number;
  children(response: {
    previewHeight: number;
    previewWidth: number;
    availableHeight: number;
    availableWidth: number;
  }): React.ReactNode;
}

const containerPadding = 32;
const innerContainerPadding = 60;
const ReportingTemplatePreviewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  headingHeight = 0,
  children,
}) => {
  const [
    { previewHeight, previewWidth, availableHeight, availableWidth },
    setContainerRef,
  ] = useDimensions(
    headingHeight,
    containerPadding,
    innerContainerPadding,
    RENDERED_DIMENSIONS,
  );

  return (
    <SimpleModal size="scale" isOpen={isOpen} showCloseButton onClose={onClose}>
      <Container ref={setContainerRef} className="reporting-template-preview">
        {children({
          previewHeight,
          previewWidth,
          availableHeight,
          availableWidth,
        })}
      </Container>
    </SimpleModal>
  );
};

export default ReportingTemplatePreviewModal;
